export default __webpack_public_path__ + "static/1022-73101a31007afdf8c726bcef2d98a1a1.gif";